export const CONTA_DEFAULT = 'Conta Gerencial';

export const CLIENTE_DEFAULT = 'Anônimo';
export const FORNECEDOR_DEFAULT = 'Anônimo';
export const FORNECEDOR_IMPORTACAO = 'Importação';
export const TIPO_PAGAMENTO_DEFAULT = 'Dinheiro';

export const ID_CLIENTE_DEFAULT = 1;
export const ID_FORNECEDOR_DEFAULT = 1;
export const ID_FORNECEDOR_IMPORTACAO = 2;

export const A_VISTA = 'Á Vista';
export const A_PRAZO = 'Á Prazo';

export const PAGO = 'Pago';
export const PARCIALMENTE_PAGO = 'Parcialmente Pago';
export const NAO_PAGO = 'Não Pago';

export const POR_PESO_VARIAVEL = 'Por Peso Variável';
export const POR_PESO_FIXO = 'Por Peso Fixo';
export const POR_UNIDADE = 'Por Unidade';
export const POR_PESO_VARIAVEL_SEM_UNIDADE = 'Por Peso Variável Sem Unidade';

export const POR_ANO = 'Anual';
export const POR_MES = 'Mensal';
export const POR_SEMANA = 'Semanal';
export const POR_DIA = 'Diario';

export const TIPO_PAGAMENTO_DINHEIRO = 'Dinheiro';
export const TIPO_PAGAMENTO_FIADO = 'Fiado';
export const TIPO_PAGAMENTO_CARTAO_CREDITO = 'Cartão de Crédito';
export const TIPO_PAGAMENTO_CARTAO_DEBITO = 'Cartão de Débito';
export const TIPO_PAGAMENTO_TED_PIX = 'TED/PIX';
export const TIPO_PAGAMENTO_BOLETO_GERENCIANET = 'Boleto';

export const ID_TIPO_PAGAMENTO_DINHEIRO = 1;
export const ID_TIPO_PAGAMENTO_FIADO = 2;
export const ID_TIPO_PAGAMENTO_CARTAO_CREDITO = 3;
export const ID_TIPO_PAGAMENTO_CARTAO_DEBITO = 4;
export const ID_TIPO_PAGAMENTO_TED_PIX = 5;
export const ID_TIPO_PAGAMENTO_BOLETO_GERENCIANET = 6;

export const CONTA_GERENCIAL = 'Gerencial';
export const CONTA_BANCO_DO_BRASIL = 'Banco do Brasil';
export const CONTA_GERENCIANET = 'Gerencianet';
export const CONTA_SANTANDER = 'Santander';

export const ID_CONTA_GERENCIAL = 1;
export const ID_CONTA_GERENCIANET = 2;
export const ID_CONTA_SANTANDER = 3;
export const ID_CONTA_BANCO_DO_BRASIL = 4;

export const USER_GERENTE = 'Gerente';
export const USER_FRENTISTA = 'Frentista';

export const CATEGORIA_TRANSACAO_FORNECEDOR = 'Fornecedores';
export const CATEGORIA_TRANSACAO_AJUSTES = 'Ajustes';
export const CATEGORIA_TRANSACAO_PAGAMENTOS = 'Pagamentos';
export const CATEGORIA_TRANSACAO_VENDAS = 'Vendas';

export const CATEGORIA_BLOCO_MAPA_LOJA_PAREDE = 'parede';
export const CATEGORIA_BLOCO_MAPA_LOJA_AREA_NEUTRA = 'area_neutra';
export const CATEGORIA_BLOCO_MAPA_LOJA_DEPOSITO = 'deposito';

export const CATEGORIAS_BLOCO_MAPA_LOJA = [
  {
    categoria: CATEGORIA_BLOCO_MAPA_LOJA_PAREDE,
    label: 'Parede',
    cor: '#616161',
  },
  {
    categoria: CATEGORIA_BLOCO_MAPA_LOJA_AREA_NEUTRA,
    label: 'Área Neutra',
    cor: '#fdd835',
  },
  {
    categoria: CATEGORIA_BLOCO_MAPA_LOJA_DEPOSITO,
    label: 'Depósito',
    cor: '#8e24aa',
  },
];

export const CATEGORIA_ENDERECO_EXPOSICAO_PORTA_PALLET = 'porta-pallet';
export const CATEGORIA_ENDERECO_EXPOSICAO_ILHA = 'ilha';
export const CATEGORIA_ENDERECO_EXPOSICAO_BACKLIGHT = 'backlight';
export const CATEGORIA_ENDERECO_EXPOSICAO_CAMARA_FRIA_RESFRIAMENTO =
  'camara-fria-resfriamento';
export const CATEGORIA_ENDERECO_EXPOSICAO_CAMARA_FRIA_CONGELAMENTO =
  'camara-fria-congelamento';
export const CATEGORIA_ENDERECO_EXPOSICAO_FREEZER = 'freezer';

export const CATEGORIAS_ENDERECO_EXPOSICAO = [
  {
    categoria: CATEGORIA_ENDERECO_EXPOSICAO_PORTA_PALLET,
    label: 'Porta-Pallet',
    cor: '#fff9c4',
    corBorda: '#f9a825',
  },
  {
    categoria: CATEGORIA_ENDERECO_EXPOSICAO_ILHA,
    label: 'Ilha',
    cor: '#c8e6c9',
    corBorda: '#43a047',
  },
  {
    categoria: CATEGORIA_ENDERECO_EXPOSICAO_BACKLIGHT,
    label: 'Backlight',
    cor: '#ffcdd2',
    corBorda: '#e53935',
  },
  {
    categoria: CATEGORIA_ENDERECO_EXPOSICAO_CAMARA_FRIA_RESFRIAMENTO,
    label: 'Câmara Fria de Resfriamento',
    cor: '#b2ebf2',
    corBorda: '#00838f',
  },
  {
    categoria: CATEGORIA_ENDERECO_EXPOSICAO_CAMARA_FRIA_CONGELAMENTO,
    label: 'Câmara Fria de Congelamento',
    cor: '#c5cae9',
    corBorda: '#283593',
  },
  {
    categoria: CATEGORIA_ENDERECO_EXPOSICAO_FREEZER,
    label: 'Freezer',
    cor: '#e1bee7',
    corBorda: '#8e24aa',
  },
];

export const TIPO_RECEITA = 'Receita';
export const TIPO_DESPESA = 'Despesa';

export const ATALHO_VOLTAR = 'F4';
export const ATALHO_AVANCAR = 'F8';
export const ATALHO_OPEN_MENU = 'insert';

export const PRIMARY_COLOR = process.env.REACT_APP_PRIMARY_COLOR;
export const SECONDARY_COLOR = process.env.REACT_APP_SECONDARY_COLOR;

export const URL_SERVIDOR_IMPRESSORA = process.env.REACT_APP_HOST_IMPRESSORA;

export const URL_SERVIDOR_IMPRESSORA_NOVO =
  process.env.REACT_APP_HOST_IMPRESSORA_NOVO;

export const URL_SERVER_RESTART = process.env.REACT_APP_URL_SERVER_RESTART;

export const STATUS_ATIVO = 'ativo';
export const STATUS_INATIVO = 'inativo';
export const STATUS_DELETADO = 'deletado';

export const PIX_EMAIL_OPTION = 'pix_email_option';
export const PIX_TELEFONE_OPTION = 'pix_telefone_option';
export const PIX_ALEATORIA_OPTION = 'pix_aleatoria_option';
export const PIX_CPF_OPTION = 'pix_cpf_option';
export const PIX_CNPJ_OPTION = 'pix_cnpj_option';

export const MALOTE_MALOTE_OPTION = 'malote_malote';
export const MALOTE_SUBMALOTE_OPTION = 'malote_submalote';
export const MALOTE_SANGRIA_OPTION = 'malote_sangria';
export const MALOTE_TROCO_OPTION = 'malote_troco';

export const TIPO_FERIADO_FERIADO = 'feriado';
export const TIPO_FERIADO_DATA_COMEMORATIVA = 'data_comemorativa';
export const TIPO_FERIADO_DIA_COMUM = 'dia_comum';

export const UNIVERSO_FERIADO_NACIONAL = 'nacional';
export const UNIVERSO_FERIADO_ESTADUAL = 'estadual';
export const UNIVERSO_FERIADO_MUNICIPAL = 'municipal';
export const UNIVERSO_FERIADO_SINDICATO = 'sindicato';

export const TIPO_OFERTA_PRODUTO_JORNAL = 'tipo_oferta_produto_jornal';
export const TIPO_OFERTA_PRODUTO_ZERAR_ESTOQUE =
  'tipo_oferta_produto_zerar_estoque';
export const TIPO_OFERTA_PRODUTO_LIBERACAO = 'tipo_oferta_produto_liberacao';

export const TIPO_UNIDADE_OFERTA_KG = 'tipo_unidade_oferta_kg';
export const TIPO_UNIDADE_OFERTA_UN = 'tipo_unidade_oferta_un';
export const TIPO_UNIDADE_OFERTA_CAIXA = 'tipo_unidade_oferta_caixa';
export const TIPO_UNIDADE_OFERTA_CAIXETA = 'tipo_unidade_oferta_caixeta';
export const TIPO_UNIDADE_OFERTA_CAIXA_MAE = 'tipo_unidade_oferta_caixa_mae';

export const APP_VERSION = '259.0.0';
export const APP_VERSION_FUNCIONALIDADES = '';

export const ZERO_APROXIMADO = 0.0099;

export const TURNO_MANHA = 'turno_manha';
export const TURNO_NOITE = 'turno_noite';
export const TURNO_12_HORAS = 'turno_12_horas';

export const STATUS_LOJA_ABERTA = 'status_loja_aberta';
export const STATUS_LOJA_FECHADA = 'status_loja_fechada';

export const TIPO_HORARIO_NORMAL = 'tipo_horario_normal';
export const TIPO_HORARIO_DOMINGO = 'tipo_horario_domingo';

export const STATUS_ANDAMENTO_ATIVIDADE_NAO_VISUALIZADA =
  'status_andamento_atividade_nao_visualizada';
export const STATUS_ANDAMENTO_ATIVIDADE_VISUALIZADA =
  'status_andamento_atividade_visualizada';
export const STATUS_ANDAMENTO_ATIVIDADE_EM_ANDAMENTO =
  'status_andamento_atividade_em_andamento';
export const STATUS_ANDAMENTO_ATIVIDADE_FINALIZADA =
  'status_andamento_atividade_finalizada';
export const STATUS_ANDAMENTO_ATIVIDADE_PROBLEMATICA =
  'status_andamento_atividade_problematica';

export const TIPO_RECORRENCIA_NAO_RECORRENCIA =
  'tipo_recorrencia_nao_recorrencia';
export const TIPO_RECORRENCIA_DIARIA_NORMAL = 'tipo_recorrencia_diaria_normal';
export const TIPO_RECORRENCIA_SEMANAL_NORMAL =
  'tipo_recorrencia_semanal_normal';
export const TIPO_RECORRENCIA_MENSAL_NORMAL = 'tipo_recorrencia_mensal_normal';
export const TIPO_RECORRENCIA_ANUAL_NORMAL = 'tipo_recorrencia_anual_normal';

export const AVALIACAO_FEITO_COM_EXCELENCIA = 'avaliacao_feito_com_excelencia';
export const AVALIACAO_MALFEITO = 'avaliacao_malfeito';
export const AVALIACAO_NAO_REALIZADO = 'avaliacao_nao_realizado';

export const REGIME_TRIBUTARIO_MEI = 'regime_tributario_mei';
export const REGIME_TRIBUTARIO_SIMPLES_NACIONAL =
  'regime_tributario_simples_nacional';
export const REGIME_TRIBUTARIO_LUCRO_PRESUMIDO =
  'regime_tributario_lucro_presumido';
export const REGIME_TRIBUTARIO_LUCRO_REAL = 'regime_tributario_lucro_real';
export const REGIME_TRIBUTARIO_PRODUTOR_RURAL =
  'regime_tributario_produtor_rural';
export const REGIME_TRIBUTARIO_SEM_NFE = 'regime_tributario_sem_nfe';

export const TIPO_PRECIFICACAO_NORMAL = 'tipo_precificacao_normal';
export const TIPO_PRECIFICACAO_COMPRA = 'tipo_precificacao_compra';
export const TIPO_PRECIFICACAO_LIBERACAO_PRECO =
  'tipo_precificacao_liberacao_preco';
export const TIPO_PRECIFICACAO_OFERTA = 'tipo_precificacao_oferta';
export const TIPO_PRECIFICACAO_ZERAR_ESTOQUE =
  'tipo_precificacao_zerar_estoque';

export const TIPO_TRANSACAO_ESPECIAL_VERBA = 'tipo_transacao_especial_verba';

export const EVENTO_MANIFESTACAO_NFE_CONFIRMACAO_DA_OPERACAO =
  'evento_manifestacao_nfe_confirmacao_da_operacao';
export const EVENTO_MANIFESTACAO_NFE_CIENCIA_DA_OPERACAO =
  'evento_manifestacao_nfe_ciencia_da_operacao';
export const EVENTO_MANIFESTACAO_NFE_DESCONHECIMENTO_DA_OPERACAO =
  'evento_manifestacao_nfe_desconhecimento_da_operacao';
export const EVENTO_MANIFESTACAO_NFE_REGISTRO_DA_OPERACAO_NÃO_FINALIZADA =
  'evento_manifestacao_nfe_registro_da_operacao_nao_finalizada';

export const LOG_TASK_CALCULA_RELATORIO_CLIENTE =
  'log_task_calcula_relatorio_cliente';
export const LOG_TASK_CALCULA_RELATORIO_PRODUTO =
  'log_task_calcula_relatorio_produto';
export const LOG_TASK_RELATORIO_ANUAL = 'log_task_relatorio_anual';
export const LOG_TASK_RELATORIO_MENSAL = 'log_task_relatorio_mensal';

export const TIPO_IMPRESSAO_KG = 'tipo_impressao_kg';
export const TIPO_IMPRESSAO_UN = 'tipo_impressao_un';

export const FATOR_CONVERSAO_XML_COMPRA_TIPO_NENHUM =
  'fator_conversao_xml_compra_tipo_nenhum';
export const FATOR_CONVERSAO_XML_COMPRA_TIPO_CAIXARIA_NIVEL_1 =
  'fator_conversao_xml_compra_tipo_caixaria_nivel_1';
export const FATOR_CONVERSAO_XML_COMPRA_TIPO_CAIXARIA_NIVEL_2 =
  'fator_conversao_xml_compra_tipo_caixaria_nivel_2';
export const FATOR_CONVERSAO_XML_COMPRA_TIPO_CAIXARIA_NIVEL_3 =
  'fator_conversao_xml_compra_tipo_caixaria_nivel_3';

export const TIPO_UNIDADE_PRECO_PRE_COMPRA_KG =
  'tipo_unidade_preco_pre_compra_kg';
export const TIPO_UNIDADE_PRECO_PRE_COMPRA_UN =
  'tipo_unidade_preco_pre_compra_un';
export const TIPO_UNIDADE_PRECO_PRE_COMPRA_CX1 =
  'tipo_unidade_preco_pre_compra_cx1';
export const TIPO_UNIDADE_PRECO_PRE_COMPRA_CX2 =
  'tipo_unidade_preco_pre_compra_cx2';
export const TIPO_UNIDADE_PRECO_PRE_COMPRA_CX3 =
  'tipo_unidade_preco_pre_compra_cx3';

export const ESTADO_FISICO_CONGELADO = 'estado_fisico_congelado';
export const ESTADO_FISICO_RESFRIADO = 'estado_fisico_resfriado';
export const ESTADO_FISICO_SECO = 'estado_fisico_seco';

export const TIPO_CONTATO_TELEFONE = 'tipo_contato_telefone';

export const TIPO_COMPRA_MERCADORIAS_REVENDA =
  'tipo_compra_mercadorias_revenda';
export const TIPO_COMPRA_INSUMOS_UTILIZACAO = 'tipo_compra_insumos_utilizacao';
export const TIPO_COMPRA_BONIFICACAO_MERCADORIAS_REVENDA =
  'tipo_compra_bonificacao_mercadorias_revenda';
export const TIPO_COMPRA_SERVICOS_PRESTADO_A_EMPRESA =
  'tipo_compra_servicos_prestado_a_empresa';

export const LABEL_TIPO_CAIXA_FARDO = 'fardo';
export const LABEL_TIPO_CAIXA_CAIXA = 'caixa';
export const LABEL_TIPO_CAIXA_GALÉIA = 'galéia';
export const LABEL_TIPO_CAIXA_SACO = 'saco';

export const TIPO_UNIDADE_KG = 'kg';
export const TIPO_UNIDADE_UN = 'un';
export const TIPO_UNIDADE_CX1 = 'cx1';
export const TIPO_UNIDADE_CX2 = 'cx2';
export const TIPO_UNIDADE_CX3 = 'cx3';

export const TIPO_PEDIDO_MINIMO_COMPRA_VALOR =
  'tipo_pedido_minimo_compra_valor';
export const TIPO_PEDIDO_MINIMO_COMPRA_KG = 'tipo_pedido_minimo_compra_kg';
export const TIPO_PEDIDO_MINIMO_COMPRA_CAIXAS =
  'tipo_pedido_minimo_compra_caixas';

export const NIVEL_CODIGO_NCM_CAPITULO = 'capitulo';
export const NIVEL_CODIGO_NCM_POSICAO = 'posicao';
export const NIVEL_CODIGO_NCM_SUB_POSICAO_1 = 'sub_posicao_1';
export const NIVEL_CODIGO_NCM_SUB_POSICAO_2 = 'sub_posicao_2';
export const NIVEL_CODIGO_NCM_ITEM = 'item';
export const NIVEL_CODIGO_NCM_SUB_ITEM = 'sub_item';

export const MOTIVO_DESONERACAO_ICMS_1 = '1';
export const MOTIVO_DESONERACAO_ICMS_3 = '3';
export const MOTIVO_DESONERACAO_ICMS_4 = '4';
export const MOTIVO_DESONERACAO_ICMS_5 = '5';
export const MOTIVO_DESONERACAO_ICMS_6 = '6';
export const MOTIVO_DESONERACAO_ICMS_7 = '7';
export const MOTIVO_DESONERACAO_ICMS_8 = '8';
export const MOTIVO_DESONERACAO_ICMS_9 = '9';
export const MOTIVO_DESONERACAO_ICMS_10 = '10';
export const MOTIVO_DESONERACAO_ICMS_11 = '11';
export const MOTIVO_DESONERACAO_ICMS_12 = '12';
export const MOTIVO_DESONERACAO_ICMS_16 = '16';
export const MOTIVO_DESONERACAO_ICMS_90 = '90';

export const DADOS_FISCAIS_TIPO_OPERACAO_VENDA = 'venda';
export const DADOS_FISCAIS_TIPO_OPERACAO_COMPRA = 'compra';

export const STATUS_NUMERACAO_NFCE_EMITIDA = 'emitida';
export const STATUS_NUMERACAO_NFCE_INUTILIZADA = 'inutilizada';
export const STATUS_NUMERACAO_NFCE_REJEITADA = 'rejeitada';
export const STATUS_NUMERACAO_NFCE_PENDENTE = 'pendente';
export const STATUS_NUMERACAO_NFCE_INDEFINIDO = 'indefinido';
export const STATUS_NUMERACAO_NFCE_CANCELADO = 'cancelado';
export const STATUS_NUMERACAO_NFCE_INDEFINIDO_CONTINGENCIA =
  'indefinido_contingencia';
export const STATUS_NUMERACAO_NFCE_CANCELADO_FAZER_DEVOLUCAO =
  'cancelado_fazer_devolucao';

export const TIPO_PAGAMENTO_PARCELA_COMPRA_CARTAO_CREDITO =
  'tipo_pagamento_parcela_compra_cartao_credito';
export const TIPO_PAGAMENTO_PARCELA_COMPRA_PIX =
  'tipo_pagamento_parcela_compra_pix';
export const TIPO_PAGAMENTO_PARCELA_COMPRA_BOLETO =
  'tipo_pagamento_parcela_compra_boleto';

export const TIPO_ALIQUOTA_IBS_CBS_PADRAO = 'padrao';
export const TIPO_ALIQUOTA_IBS_CBS_UNIFORME_SETORIAL = 'uniforme_setorial';
export const TIPO_ALIQUOTA_IBS_CBS_UNIFORME_NACIONAL = 'uniforme_nacional';
export const TIPO_ALIQUOTA_IBS_CBS_FIXA = 'fixa';
export const TIPO_ALIQUOTA_IBS_CBS_SEM_ALIQUOTA = 'sem_aliquota';

export const TIPO_MOVIMENTACAO_ESTOQUE_ENTRADA = 'entrada';
export const TIPO_MOVIMENTACAO_ESTOQUE_SAIDA = 'saida';

export const ORIGEM_MOVIMENTACAO_ESTOQUE_VENDA = 'venda';
export const ORIGEM_MOVIMENTACAO_ESTOQUE_COMPRA = 'compra';
export const ORIGEM_MOVIMENTACAO_ESTOQUE_AVARIA = 'avaria';
export const ORIGEM_MOVIMENTACAO_ESTOQUE_CORRECAO = 'correcao';
export const ORIGEM_MOVIMENTACAO_ESTOQUE_DEVOLUCAO_VENDA = 'devolucao_venda';
export const ORIGEM_MOVIMENTACAO_ESTOQUE_AJUSTE_STATUS_PRODUTO =
  'ajuste_status_produto';

export const STATUS_EMISSAO_NFCE_PENDENTE = 'pendente';
export const STATUS_EMISSAO_NFCE_PROCESSANDO = 'processando';
export const STATUS_EMISSAO_NFCE_INDEFINIDA = 'indefinida';
export const STATUS_EMISSAO_NFCE_CONTINGENCIA = 'contingencia';
export const STATUS_EMISSAO_NFCE_AUTORIZADA = 'autorizada';
export const STATUS_EMISSAO_NFCE_REJEITADA = 'rejeitada';
export const STATUS_EMISSAO_NFCE_CANCELADA = 'cancelada';
export const STATUS_EMISSAO_NFCE_DENEGADA = 'denegada';
export const STATUS_EMISSAO_NFCE_CONTINGENCIA_ENVIADA = 'contingencia_enviada';
export const STATUS_EMISSAO_NFCE_AUTORIZADA_SEM_XML = 'autorizada_sem_xml';
export const STATUS_EMISSAO_NFCE_REJEITADA_DEFINITIVO = 'rejeitada_definitivo';
export const STATUS_EMISSAO_NFCE_DESCONHECIDO = 'desconhecido';
export const STATUS_EMISSAO_NFCE_REJEITADA_REPROCESSAMENTO =
  'rejeitada_reprocessamento';

// Sub-máquina de estados do documento de devolução emitido na conversão
// NFC-e -> NF-e (espelho do server/worker-notas-fiscais).
export const STATUS_DEVOLUCAO_NFCE_PENDENTE = 'pendente';
export const STATUS_DEVOLUCAO_NFCE_PROCESSANDO = 'processando';
export const STATUS_DEVOLUCAO_NFCE_AUTORIZADA = 'autorizada';
export const STATUS_DEVOLUCAO_NFCE_REJEITADA = 'rejeitada';
export const STATUS_DEVOLUCAO_NFCE_INDEFINIDA = 'indefinida';
// Terminal: nenhum cron varre; só "Reiniciar conversão" (com a digital do gerente) a tira daqui.
export const STATUS_DEVOLUCAO_NFCE_FALHA_DEFINITIVA = 'falha_definitiva';

// Interruptor da geração do pacote fiscal mensal pela interface: com false somem
// o botão "Gerar pacote" (Acompanhamento fiscal), a opção "Pacote mensal" do
// diálogo "Gerar relatório fiscal" e o "Reprocessar" das execuções de pacote.
// Só esconde na tela: a rota do servidor (POST relatorios_fiscais_execucoes/pacote)
// continua existindo, e a reingestão de período e o download de pacotes já
// gerados seguem funcionando.
export const GERAR_PACOTE_FISCAL_HABILITADO = false;

// Interruptor da reingestão de período pelo botão "Gerar" do histórico de
// relatórios fiscais: com false o botão some (a menos que a geração de pacote
// esteja ligada, que também usa o diálogo). Só esconde na tela: a rota do
// servidor (POST relatorios_fiscais_execucoes/ingestao) continua existindo, e a
// reingestão de um dia pelo Acompanhamento segue funcionando.
export const GERAR_INGESTAO_PERIODO_HABILITADA = false;

// Interruptor da conversão NFC-e -> NF-e na lista de NFC-e: com false o botão
// "Converter NFC-e em NF-e" não aparece. Só esconde o botão na tela; a rota do
// servidor (POST fiscal_nfces/:id/converter-nfe) continua existindo. Conversões
// já iniciadas continuam com "Reprocessar", "Consultar", "Reiniciar" e "Detalhes".
export const CONVERSAO_NFCE_HABILITADA = false;

// Janela de tempo para oferecer a conversão NFC-e -> NF-e.
// Referência: vendas.data_autorizacao da NFC-e.
export const PRAZO_MIN_CONVERSAO_NFCE_MINUTOS = 30; // = prazo máx. de cancelamento da NFC-e
// = prazo máx. de devolução (manter igual ao server). Regra de negócio: além
// desse teto de dias, a conversão só vale dentro do mesmo mês civil da
// autorização (ver mesmoMesCivil em cancelamentoFiscal.js).
export const PRAZO_MAX_CONVERSAO_NFCE_DIAS = 4;

export const STATUS_EMISSAO_NFE_PENDENTE = 'pendente';
export const STATUS_EMISSAO_NFE_PROCESSANDO = 'processando';
export const STATUS_EMISSAO_NFE_INDEFINIDA = 'indefinida';
export const STATUS_EMISSAO_NFE_CONTINGENCIA = 'contingencia';
export const STATUS_EMISSAO_NFE_AUTORIZADA = 'autorizada';
export const STATUS_EMISSAO_NFE_REJEITADA = 'rejeitada';
export const STATUS_EMISSAO_NFE_CANCELADA = 'cancelada';
export const STATUS_EMISSAO_NFE_DENEGADA = 'denegada';
export const STATUS_EMISSAO_NFE_CONTINGENCIA_ENVIADA = 'contingencia_enviada';
export const STATUS_EMISSAO_NFE_AUTORIZADA_SEM_XML = 'autorizada_sem_xml';
export const STATUS_EMISSAO_NFE_REJEITADA_DEFINITIVO = 'rejeitada_definitivo';
export const STATUS_EMISSAO_NFE_DESCONHECIDO = 'desconhecido';
export const STATUS_EMISSAO_NFE_REJEITADA_REPROCESSAMENTO =
  'rejeitada_reprocessamento';

export const TIPO_DEDO_BIOMETRIA_POLEGAR_DIREITO = 'polegar_direito';
export const TIPO_DEDO_BIOMETRIA_INDICADOR_DIREITO = 'indicador_direito';
export const TIPO_DEDO_BIOMETRIA_MEDIO_DIREITO = 'medio_direito';
export const TIPO_DEDO_BIOMETRIA_ANELAR_DIREITO = 'anelar_direito';
export const TIPO_DEDO_BIOMETRIA_MINIMO_DIREITO = 'minimo_direito';

export const TIPO_DEDO_BIOMETRIA_POLEGAR_ESQUERDO = 'polegar_esquerdo';
export const TIPO_DEDO_BIOMETRIA_INDICADOR_ESQUERDO = 'indicador_esquerdo';
export const TIPO_DEDO_BIOMETRIA_MEDIO_ESQUERDO = 'medio_esquerdo';
export const TIPO_DEDO_BIOMETRIA_ANELAR_ESQUERDO = 'anelar_esquerdo';
export const TIPO_DEDO_BIOMETRIA_MINIMO_ESQUERDO = 'minimo_esquerdo';

export const stylesMalote = {
  statusHeader: {
    paddingLeft: '30px',
    flex: 1,
    backgroundColor: SECONDARY_COLOR,
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  statusCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
    paddingLeft: '30px',
  },
  statusContent: {
    flex: 5,
    marginLeft: '30px',
    maxWidth: '100px',
  },
  dataHeader: {
    flex: 1,
    backgroundColor: SECONDARY_COLOR,
    padding: '10px',
    color: 'white',
    fontWeight: 'bold',
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  descricaoHeader: {
    flex: 2,
    backgroundColor: '#f8f8f8',
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  descricaoCell: {
    flex: 2,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  categoriaHeader: {
    flex: 2,
    backgroundColor: '#f8f8f8',
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  categoriaCell: {
    flex: 2,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  contaHeader: {
    flex: 2,
    backgroundColor: '#f8f8f8',
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  contaCell: {
    flex: 2,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  valorHeader: {
    flex: 1,
    backgroundColor: '#f8f8f8',
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  valorCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  actionsHeader: {
    flex: 1,
    backgroundColor: '#f8f8f8',
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
    paddingRight: '100px',
  },
  actionsCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
    paddingRight: '100px',
  },
};
